import { gql } from '@apollo/client';

export const GET_VERIFICATIONS = gql`
  query readVerificationView($filter: VerificationViewInput) {
    readVerificationView(filter: $filter) {
      latitude
      longitude
      BarCodeNumber
      description
      VerifyDate
      UserId
    }
  }
`;
